import { cmsBaseUrl } from "../../../config/GlobalConfig";




export default function LoginEntrepriseCoverBloc() {

    return (

        <div className="bloc-coadherent--cover ta-center">
            <p className="chapo bleu mb-lg">ESPACE EMPLOYEUR MGP</p>
            <span className="border-fushia"></span>
            <h1 className="page-title m-y-lg">Découvrez votre espace employeur</h1>
            <img src={cmsBaseUrl + "/files/live/sites/mgp/files/images/connexion-espace-employeur.png"} alt="espace employeur "/>
            <p className="text mt-lg">
                Grâce à votre espace employeur, gagnez du temps dans vos démarches et gérez les contrats de vos collaborateurs en toute simplicité. Vous pouvez consulter vos documents contractuels, affilier en ligne vos collaborateurs ou encore créer des accès et des habilitations pour vos gestionnaires.
                <br/>
                Munissez-vous de votre email ainsi que de votre mot de passe pour vous connecter à votre espace.
            </p>    
        </div>
  )
}